export enum DATOCMS_ENVS {
  main = 'main',
  dev = 'develop',
  preprod = 'preprod',
}

export const PRODUCT_API_URL = process.env.NEXT_PUBLIC_PRODUCT_API_URL as string;
export const DATOCMS_API_URL = process.env.NEXT_PUBLIC_DATOCMS_API_URL as string;
export const DATOCMS_API_KEY = process.env.NEXT_PUBLIC_DATOCMS_API_KEY as string;
export const DATA_DATOCMS_ENV = (process.env.NEXT_PUBLIC_DATOCMS_ENV as DATOCMS_ENVS | '') || DATOCMS_ENVS.main;
export const WEATHER_API_URL = process.env.NEXT_PUBLIC_WEATHER_API_URL as string;
export const WEATHER_API_KEY = process.env.NEXT_PUBLIC_WEATHER_API_KEY as string;

// Set to 4s due to 5s edge middleware limit
export const DATOCMS_API_TIMEOUT_IN_MS = 4000;

export const CHECKOUT_API_PREFIX = 'checkout/v2/';
export const CURRENCIES_API_PREFIX = 'currencies/v1/';
export const OFFERS_API_PREFIX = 'offers/v2/';
export const AMENDMENT_API_PREFIX = 'amendment/v1/';
export const RESERVATION_V2_API_PREFIX = 'reservation/v2/';
